import { RequestStatus } from '@upright/ui/api/common/types';
import { Side } from '@upright/ui/common/upright/core/impact-lens-profile/common/layout/types';
import { useCarouselContext, useCarouselLayout } from '@upright/ui/common/upright/core/impact-lens-profile/context';
import { CSSProperties } from 'react';
import Skeleton from 'react-loading-skeleton';
import styled from 'styled-components';

export function LensLoadingState() {
  const { data } = useCarouselContext();
  const loading = data.loadingStatus === RequestStatus.LOADING;
  if (!loading) {
    return <></>;
  }
  return (
    <>
      <DataLoadingSide side={Side.RIGHT} />
      <DataLoadingSide side={Side.LEFT} />
    </>
  );
}

interface DataLoadingSideProps {
  side: Side;
}

export function DataLoadingSide(props: DataLoadingSideProps) {
  const layout = useCarouselLayout();
  const dataArea = layout.dataArea(props.side);
  const boxesArea = layout.boxesArea(props.side);

  const x1 = Math.min(boxesArea.x1, dataArea.x1);
  const x2 = Math.max(boxesArea.x2, dataArea.x2);
  const width = x2 - x1;

  const margin = 10;
  const left = props.side === Side.LEFT ? x1 : x1 + margin;

  const style: CSSProperties = {
    top: dataArea.y1,
    width: width - margin,
    left,
    height: dataArea.height,
  };
  return (
    <div>
      <StyledSkeleton style={style} />
      <Text style={style}>Loading data...</Text>
    </div>
  );
}

const StyledSkeleton = styled(Skeleton)`
  position: absolute;
`;

const Text = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  color: black;
  font-size: 14px;
`;
